import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  toggleSearchBoxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "1.3rem",
    marginBottom: "1.3rem",
    height: theme.dimensions.nav.menuHeight.md,
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      flexDirection: "row",
      position: "relative",
      marginTop: "unset",
      marginBottom: "unset",
    }
  },
  toggleSearchBox: {
    position: "relative",
    width: theme.dimensions.nav.searchToggle.width,
    backgroundColor: 'transparent',
    alignSelf: "center",
    background: "none",
    overflow: "visible",
    transition: "all 0.3s ease-in-out",
    border: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 0,
    padding: theme.dimensions.nav.searchToggle.buttonPadding,
    minHeight: theme.dimensions.nav.searchToggle.height,

    "&:before": {
      display: "block",
      content: "''",
      position: "absolute",
      backgroundColor: theme.palette.purple,
      width: "100%",
      height: "100%",
      zIndex: 0,
      alignSelf: "center",
      justifySelf: "center",
      opacity: 0,
      [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        width: "90%",
        height: "50%",
      }
    },

    "&:hover": {
      svg: {
        color: theme.palette.yellow,
      },
    },
    "&:focus": {
      outline: "none",

      "&:before": {
        opacity: 1
      }
    },
    "&.open": {
      backgroundColor: theme.palette.gridPurple,
    },
    "&.closed": {
      backgroundColor: "transparent",
    },

    "&.filled": {
      height: "10.6em"
    },
    "&.empty": {
      height: "6.3em",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      minHeight: "unset",
      height: "100%",
      "&.open": {
        backgroundColor: theme.palette.gridPurple,
        height: theme.dimensions.nav.searchToggle.height,
        "&:focus": {
          "&:before": {
            opacity: 1
          }
        },
      },
      "&.closed": {
        backgroundColor: "transparent",
        "&:focus": {
          outline: "none",
          svg: {
            color: theme.palette.yellow,
          },
        },
      },

      "&.filled": {
        maxHeight: "unset",
        height: "100%"
      },
      "&.empty": {
        height: "100%",
        maxHeight: "unset"
      },
    }
  },
  searchContainer: {
    backgroundColor: theme.palette.gridPurple,
    transitionProperty: "all",
    transitionDuration: "0.15s",
    transitionTimingFunction: theme.transitions.easing.sharp,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    position: "relative",
    top: 0,
    "&.open": {
      maxWidth: "100vw",
      maxHeight: "unset",
    },
    "&.closed": {
      maxWidth: 0,
      maxHeight: "unset"
    },
    "&.filled": {
      height: "10em"
    },
    "&.empty": {
      maxHeight: "6em",
      height: "100%"
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "auto",
      transitionProperty: "max-height",
      position: "absolute",
      top: "100%",
      right: 0,
      "&.closed": {
        maxHeight: 0
      },
    }
  },
  searchInput: {
    fontFamily: "FuturaStd",
    fontWeight: 600,
    fontSize: theme.fontSizes.navSearch.md,
    color: theme.palette.yellow,
    padding: theme.dimensions.nav.searchToggle.searchBoxPadding,
    transitionProperty: "all",
    transitionDuration: "0.15s",
    transitionTimingFunction: theme.transitions.easing.sharp,
    minWidth: '19vw',
    border: "none",
    background: "none",
    borderRadius: 0,
    alignSelf: "center",
    position: "relative",
    bottom: "0",
    marginBottom: "1em",
    margintop: "1em",
    boxSizing: "border-box",
    display: "flex",
    lineHeight: "1em",
    justifySelf: "flex-end",
    alightSelf: "flex-end",
    "&:after": {
      display: "none"
    },
    "&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill-selected": {
      color: theme.palette.yellow,
      backgroundColor: "transparent"
    },
    "&:focus": {
      border: "none",
      outline: theme.palette.gridPurple
    },
    "&.filled": {
      transform: "translateY(0)"
    },
    "&.empty": {
      transform: "translateY(0)"
    },
    "&.open": {
      opacity: 1
    },
    "&.closed": {
      opacity: 1
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      "&.open": {
        opacity: 1
      },
      "&.closed": {
        opacity: 0
      },
    }
  },
  searchLabel: {
    fontFamily: "FuturaStd",
    fontWeight: 600,
    padding: theme.dimensions.nav.searchToggle.searchBoxPadding,
    fontSize: theme.fontSizes.navSearch.md,
    color: theme.palette.yellow,
    letterSpacing: theme.fontSizes.letterSpacing,
    transitionProperty: "all",
    transitionDuration: "0.15s",
    transitionTimingFunction: theme.transitions.easing.sharp,
    alignSelf: "flex-start",
    justifySelf: "flex-start",
    transformOrigin: "0% 0%",
    position: "absolute",
    bottom: 0,
    boxSizing: "border-box",
    display: "block",
    "&.aside": {
      opacity: 1,
      transform: 'scale(0.8) translateY(0)'
    },
    "&.front": {
      opacity: 1,
      transform: 'scale(1) translateY(0)'
    },
    "&.open": {
      transitionProperty: "visibility",
      transitionDuration: "0s",
      visible: "hidden"
    },
    "&.closed": {
      transitionProperty: "visibility",
      transitionDuration: "0.0s",
      transitionDelay: "0.3s",
      visibility: "hidden"
    },
  },
  svg: {
    width: theme.dimensions.nav.searchToggle.width,
    height: "auto",
    color: theme.palette.white,
    zIndex: 1,
    "&:hover": {
      color: theme.palette.yellow,
    },
    "&.open": {
      color: theme.palette.yellow,
    },
    "&.closed": {
      color: theme.palette.white,
    },
  },
}));
